import React, { useEffect, useState } from 'react'
import AdministrationForm from '../UI/AdministrationForm/AdministrationForm'
import helper from '../../Services/helper'

const Branch = (props) => {
    const [modal, setModal] = useState()
    const t = (key) => {
        return helper().translate(key);
    }

    const headers = [
        { key: 'name', columnName: t('NAME'), typeOfInput: 'input', required: true },
        { key: 'unitNo', columnName: t('UNIT_NUMBER'), typeOfInput: 'input', required: false },
        { key: 'address', columnName: t('ADDRESS'), typeOfInput: 'input', required: false },
        { key: 'contactPerson', columnName: t('CONTACT_PERSON'), typeOfInput: 'input', required: false },
        { key: 'email', columnName: t('EMAIL'), typeOfInput: 'input', required: false },
        { key: 'phone', columnName: t('PHONE'), typeOfInput: 'input', required: false },
    ]

    const model = {
        id: 0,
        name: "",
        unitNo: "", 
        address: "",
        contactPerson: "",
        email: "",
        phone: "",
        status: 0
    }

    useEffect(() => {
        setModal(props.modal)
    }, [props.modal]);

    return (
        <div>
            <AdministrationForm new={modal} headers={headers} table="Branches" name="braches" model={model} formType="modal" />
        </div>
    )
}

export default Branch
